import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
@Component({
  selector: "app-info-modal",
  templateUrl: "./info-modal.component.html",
  styleUrls: ["./info-modal.component.scss"],
})
export class InfoModalComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<InfoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.dialogRef.disableClose = true;
  }

  ngOnInit() {
    if (!this.data.existingData) {
      if (!this.data.message) {
        this.data.message = "...";
      }
    }
  }

  closeDialog(result) {
    this.dialogRef.close(result);
    return result;
  }
}
